import { ScreenInfo } from "@components/screens/ScreenInfoPage";
import { ScreenIdType } from "@components/screens/data";
import { createContext, useContext, useEffect, useState } from "react";
import { Screen } from "@hooks/useScreens/types";
import { useScreens } from "@hooks/useScreens";

type ScreenReturnProps = {
  screenInfo: ScreenInfo | undefined;
  setScreenInfo: (screen: ScreenInfo) => void;
};

const screenContext = createContext<ScreenReturnProps | null>(null);
const { Provider } = screenContext;

type Props = {
  children: React.ReactNode;
  screen?: Screen;
};

export function ScreenProvider({ children, screen: screen }: Props) {
  const { screens } = useScreens()
  const [screenInfo, setScreenInfo] = useState<ScreenReturnProps["screenInfo"]>(
    screen
      ? {
        locationId: screen.location_id ?? "",
        zone_id: screen.zone_id || undefined,
        group_id: screen.group_id || undefined,
        name: screen.name ?? "",
        screenType: screen.screen_type as ScreenIdType,
        id: screen.id,
      }
      : undefined,
  );
  useEffect(() => {
    const screen = screens.find(s => s.id === screenInfo?.id)
    setScreenInfo(s => ({
      ...s,
      locationId: screen?.location_id ?? "",
      zone_id: screen?.zone_id || undefined,
      group_id: screen?.group_id || undefined,
      name: screen?.name ?? "",
      screenType: screen?.screen_type as ScreenIdType,
    }))
  }, [screens])

  return (
    <Provider
      value={{
        screenInfo,
        setScreenInfo,
      }}
    >
      {children}
    </Provider>
  );
}

export function useScreen(): ScreenReturnProps {
  return useContext(screenContext) ?? { screenInfo: undefined, setScreenInfo: () => { } };
}
